import {
  Component,
  ViewChild,
  EventEmitter,
  Output,
  TemplateRef,
  SimpleChanges,
  inject,
} from '@angular/core';
import { RefreshGridService } from '../../../../../shared/services/refresh-grid.service'; // Import the shared service\
import { RequestStatusEnum } from '../../../../../enums/requestStatusEnum';
import {
  GridModule,
} from '@progress/kendo-angular-grid';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { InputsModule, SliderModule } from '@progress/kendo-angular-inputs';
import {
  KENDO_LAYOUT,
  LayoutModule,
} from '@progress/kendo-angular-layout';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';
import {
  KENDO_ICONS,
  IconsModule,
  SVGIcon,
} from '@progress/kendo-angular-icons';
import { KENDO_BUTTONS, ButtonsModule } from '@progress/kendo-angular-buttons';
import { LabelModule } from '@progress/kendo-angular-label';
import {
  AutoCompleteComponent,
  DropDownsModule,
} from '@progress/kendo-angular-dropdowns';
import { ListViewModule } from '@progress/kendo-angular-listview';
import { GaugesModule } from '@progress/kendo-angular-gauges';
import { IntlModule } from '@progress/kendo-angular-intl';
import { PopupRef } from '@progress/kendo-angular-popup';
import {
  searchIcon,
  caretAltDownIcon,
} from '@progress/kendo-svg-icons';

import { CommonModule } from '@angular/common';
import { Input, ElementRef } from '@angular/core';
import {
  PopupModule,
  Align,
  AnimationDirection,
  AnimationType,
  PopupAnimation,
} from '@progress/kendo-angular-popup';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { ShownotificationService } from '../../../../../services/shownotification.service';
import { UserrequestService } from '../../../../../services/userrequest.service';
import { KENDO_INDICATORS } from '@progress/kendo-angular-indicators';
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-request-remove-user-activity-panel',
  standalone: true,
  templateUrl: './request-remove-user-activity-panel.component.html',
  styleUrl: './request-remove-user-activity-panel.component.scss',
  imports: [
    KENDO_LAYOUT,
    KENDO_ICONS,
    KENDO_BUTTONS,
    KENDO_INDICATORS,
    GridModule,
    ChartsModule,
    InputsModule,
    SliderModule,
    LayoutModule,
    ScrollViewModule,
    IconsModule,
    ButtonsModule,
    LabelModule,
    DropDownsModule,
    ListViewModule,
    FormsModule,
    ReactiveFormsModule,
    GaugesModule,
    IntlModule,
    PopupModule,
    CommonModule,
    NgxSpinnerModule
  ],
})
export class RequestRemoveUserActivityPanelComponent {
  @Input() openUserRemovePopup!: boolean;
  @Input() removeUserData: any;
  @Input() selectedRequestId!: number;
  @Input() anchor!: any;
  @Input() requestStatus!: string;
  @Input() isApprovalUser: boolean = false;
  @Output() closeEvent = new EventEmitter<void>();
  @Output() userRemovalButtonEvent = new EventEmitter<void>();

  @ViewChild('popupContent') popupContent!: TemplateRef<any>;

  private popupRef: PopupRef | undefined;

  @ViewChild('autocomplete', { static: false })
  public autocomplete!: AutoCompleteComponent;

  public searchIcon: SVGIcon = searchIcon;
  public caretAltDownIcon: SVGIcon = caretAltDownIcon;

  public userRemovalDetailsForm!: FormGroup;
  public enabled = true;
  public duration = 200;
  public type: AnimationType = 'slide';
  public direction: AnimationDirection = 'left';
  public margin = { horizontal: -100, vertical: -220 };
  public RequestStatusEnum = RequestStatusEnum;

  public anchorAlign: Align = { horizontal: 'right', vertical: 'center' };
  public popupAlign: Align = { horizontal: 'right', vertical: 'center' };

  public get animate(): boolean | PopupAnimation {
    if (this.enabled) {
      return {
        type: this.type,
        direction: this.direction,
        duration: this.duration,
      };
    }
    return false;
  }
  public defaultItem: any = {
    id: 3,
    userRole: 'Engagement User',
  };

  public userProfile: any;
  public userDetails: any[] = [];
  loggedInUserRole: string = '';
  message: string = '';
  public isDisplayloader: boolean = false;

  private readonly userrequestService = inject(UserrequestService);
  private readonly fb = inject(FormBuilder);
  private readonly shownotificationService = inject(ShownotificationService);
  private readonly refreshGridService = inject(RefreshGridService);
  private spinner = inject(NgxSpinnerService);

  ngOnChanges(changes: SimpleChanges) {
    this.spinner.show();
    if (changes['removeUserData']) {
      this.message="";
      if (this.requestStatus === RequestStatusEnum.Pending && !this.isApprovalUser) {
        this.message = 'Request is Pending';
      } else if (this.requestStatus === RequestStatusEnum.Approved && this.isApprovalUser) {
        this.message = 'Already Approved';
      } else if (this.requestStatus === RequestStatusEnum.Rejected) {
        this.message = 'Already Rejected';
      } else if (this.requestStatus === RequestStatusEnum.Completed) {
        this.message = 'Already Completed';
      }

      if (this.removeUserData) {
        this.setUserRemovalRequestDetailsForm();
        this.removeUserData.activityStream = [{ description: this.removeUserData.requestUserComment, date: new Date(this.removeUserData.requestedOn), title: this.removeUserData.requestUserDisplayName, subtitle: 'Requester' }];
         if (!(this.isApprovalUser && (this.requestStatus === RequestStatusEnum.Pending))) {
          this.removeUserData.activityStream.push({ description: this.removeUserData.approvalUserComment, date: new Date(this.removeUserData.approvedUserActionedOn), title: this.removeUserData.approvalUserDisplayName, subtitle: 'Approver' });
          if (this.requestStatus === RequestStatusEnum.Completed) {
            this.removeUserData.activityStream.push({ description: this.removeUserData.supportUserComment, date: new Date(this.removeUserData.completedOn), title: this.removeUserData.supportUserDisplayName, subtitle: 'Support User' });
          }
        }
      } else {
        this.isDisplayloader = true;
        this.spinner.show();
      }
    }
  }

  ngOnInit(): void {
    this.userProfile = JSON.parse(localStorage.getItem('userProfile') ?? '');
    this.createUserRemovalRequestDetailsForm();
    this.isDisplayloader = true;
    this.spinner.show();
    if (this.removeUserData) {
      this.setUserRemovalRequestDetailsForm();
    }
  }

  public open(): void {
    this.openUserRemovePopup = true;
    //this.resetUserRemovalRequestDetailsForm();
  }

  public close(): void {
    this.openUserRemovePopup = false;
    this.closeEvent.emit();
    //this.resetUserRemovalRequestDetailsForm();
  }

  public setUserRemovalRequestDetailsForm(comment?: string): void {
    if (
      this.removeUserData &&
      this.userRemovalDetailsForm
    ) {
      this.userRemovalDetailsForm.setValue({
        requestId: this.removeUserData.requestId,
        name: this.removeUserData?.name ?? '',
        userId: this.removeUserData.userId,
        userEmail: this.removeUserData.userEmail,
        engagementName: this.removeUserData.engagementName,
        engagementId: this.removeUserData.engagementId,
        userRequestRoleTypeId: this.removeUserData.userRequestRoleTypeId,
        RequestUserId: this.removeUserData.requestUserId,
        RequestUserEmail: this.removeUserData.requestUserEmail,
        ApprovalUserId: this.isApprovalUser ? this.userProfile.id : this.removeUserData.approvalUserId,
        ApprovalUserEmail: this.isApprovalUser ? this.userProfile.email : this.removeUserData.approvalUserEmail,
        ApprovalUserComment: this.isApprovalUser ? (comment ?? '') : this.removeUserData.approvalUserComment,
        SupportUserId: !this.isApprovalUser ? this.userProfile.id : null,
        SupportUserEmail: !this.isApprovalUser ? this.userProfile.email : null,
        SupportUserComment: comment ?? '',
      });
      this.isDisplayloader = false;
      this.spinner.hide();
    }
  }

  public createUserRemovalRequestDetailsForm(): void {
    this.userRemovalDetailsForm = this.fb.group({
      requestId: [null, Validators.required],
      name: [null, Validators.required],
      userId: [null, Validators.required],
      userEmail: [null, Validators.required],
      engagementName: [null, Validators.required],
      engagementId: [null, Validators.required],
      userRequestRoleTypeId: [null, Validators.required],
      RequestUserId: [null],
      RequestUserEmail: [null],
      ApprovalUserId: [null],
      ApprovalUserEmail: [null],
      ApprovalUserComment: [null],
      SupportUserId: [null],
      SupportUserEmail: [null],
      SupportUserComment: [null],
    });
  }

  public handleKeydown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      this.close();
    }
  };

  public approveOrDenyUserRemovalRequestDetails(
    isApproveOrDeny: boolean
  ): void {
    const comment = this.userRemovalDetailsForm?.value.ApprovalUserComment;
    this.setUserRemovalRequestDetailsForm(comment);
    this.isDisplayloader = true;
    this.spinner.show();
    let userId = this.userRemovalDetailsForm?.value.userId;
    let engagementId = this.userRemovalDetailsForm?.value.engagementId;

    if (this.userRemovalDetailsForm.valid) {
      if (userId && engagementId) {
        this.userrequestService
          .approveOrDenyUserRemovalRequestDetails(
            this.userRemovalDetailsForm.value,
            this.selectedRequestId,
            isApproveOrDeny
          )
          .subscribe({
            next: () => {
              this.isDisplayloader = false;
              this.spinner.hide();
              isApproveOrDeny
                ? this.shownotificationService.showNotification(
                  'ApproveUserRemovalSuccess'
                )
                : this.shownotificationService.showNotification(
                  'RejectUserRemovalSuccess'
                );
              //this.approveOrDenyUserRemovalButtonEvent.emit();
              this.refreshGridService.refreshRequestGrid.next(true);
              this.close();
            },
            error: (error) => {
              this.close();
              // this.shownotificationService.showNotification('userRemovalRequestAlreadyExistError',error.error.message);
              this.isDisplayloader = false;
              this.spinner.hide();
            },
          });
      } else {
        this.close();
        this.shownotificationService.showNotification('userRequestError');
        this.isDisplayloader = false;
        this.spinner.hide();
      }
    }
  }

  public completeUserRemovalRequestDetails(): void {
    const comment = this.userRemovalDetailsForm?.value.SupportUserComment;
    this.setUserRemovalRequestDetailsForm(comment);
    this.isDisplayloader = true;
    this.spinner.show();
    let userId = this.userRemovalDetailsForm?.value.userId;
    let engagementId = this.userRemovalDetailsForm?.value.engagementId;

    if (this.userRemovalDetailsForm.valid) {
      if (userId && engagementId) {
        this.userrequestService
          .RemoveUserDetail(
            this.userRemovalDetailsForm.value,
            this.selectedRequestId
          )
          .subscribe({
            next: () => {
              this.isDisplayloader = false;
              this.spinner.hide();
              this.shownotificationService.showNotification(
                'userRemovedSuccess'
              );
              //this.userRemovalButtonEvent.emit();
              this.refreshGridService.refreshRequestGrid.next(true);
              this.close();
            },
            error: (error) => {
              // this.shownotificationService.showNotification('userRemovalRequestAlreadyExistError',error.error);

              var errorResult = JSON.parse(error.error);
              if (errorResult.StatusCode == '500') {
                this.shownotificationService.showNotification(
                  errorResult.StatusCode,
                  errorResult.StatusCode + ':Internal Server Error'
                );
              } else if (errorResult.StatusCode == '503') {
                this.shownotificationService.showNotification(
                  errorResult.StatusCode,
                  errorResult.StatusCode + ':Service Unavailable'
                );
              } else {
                this.shownotificationService.showNotification(
                  'userRemovedErrorFromEntraGroupId',
                  errorResult.ErrorMessage
                );
              }
              this.close();
              this.isDisplayloader = false;
              this.spinner.hide();
            },
          });
      } else {
        this.close();
        this.shownotificationService.showNotification('userRequestError');
        this.isDisplayloader = false;
        this.spinner.hide();
      }
    }
  }

  public cancelUserRemovalRequestDetails(): void {
    this.close();
  }
}
